import { useEffect, useState } from "react";
import styles from "./ProductGallery.module.css";

// Vertical thumbnail strip + main image. `images` is `[{ src, alt }]` or
// plain string URLs. Selected index resets when the image set changes.
export default function ProductGallery({ images = [], caption }) {
  const list = images.map((i) => (typeof i === "string" ? { src: i } : i));
  const [idx, setIdx] = useState(0);
  useEffect(() => { setIdx(0); }, [images]);
  if (!list.length) return <div className={styles.empty} />;
  const active = list[idx] || list[0];

  return (
    <div className={styles.gallery}>
      <div className={styles.thumbs}>
        {list.map((img, i) => (
          <button
            key={i}
            type="button"
            className={[styles.thumb, i === idx ? styles.active : ""].join(" ")}
            onClick={() => setIdx(i)}
            aria-label={`View image ${i + 1}`}
          >
            <img src={img.src} alt={img.alt || ""} loading="lazy" />
          </button>
        ))}
      </div>
      <div className={styles.main}>
        <img src={active.src} alt={active.alt || ""} className={styles.mainImage} />
        {caption ? <div className={styles.caption}>{caption}</div> : null}
      </div>
    </div>
  );
}
